<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <VueInput
          :error="errors.default_yarn_count"
          label="Yarn Count"
          v-model="modelValues.default_yarn_count"
        />
      </div>
      <div class="col-md-6">
        <VueInput
          :error="errors.default_density"
          label="Density"
          v-model="modelValues.default_density"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <VueInput
          :error="errors.default_weight"
          label="Weight"
          v-model="modelValues.default_weight"
        />
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Finish</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.default_finish"
              :options="fieldValues.finishes"
              v-if="!switchToManualFinishingInput"
            />
            <input
              v-if="switchToManualFinishingInput && !isReadOnlyUser"
              type="text"
              class="form-control"
              v-model="modelValues.default_finish"
              @change="newFinishingSubmitted"
              placeholder="Type new finishing name"
            />
            <p
              class="input-switcher"
              @click="
                switchToManualFinishingInput = !switchToManualFinishingInput
              "
              v-if="!isReadOnlyUser"
            >
              {{
                switchToManualFinishingInput
                  ? "Select existing finishing"
                  : "Create new finishing"
              }}
            </p>
            <small v-if="errors.default_finish" class="form-text text-danger">{{
              errors.default_finish.join(" ")
            }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Usage type</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.usage_type"
              :options="fieldValues.usageTypes"
            />
            <small v-if="errors.usage_type" class="form-text text-danger">{{
              errors.usage_type.join(" ")
            }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Knit type</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.knit_type"
              :options="fieldValues.knitTypes"
            />
            <small v-if="errors.knit_type" class="form-text text-danger">{{
              errors.knit_type.join(" ")
            }}</small>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Coloring Style</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.default_coloring_style"
              :options="fieldValues.coloringStyles"
              v-if="!switchToManualColorStyleInput"
            />
            <input
              v-if="switchToManualColorStyleInput && !isReadOnlyUser"
              type="text"
              class="form-control"
              v-model="modelValues.default_coloring_style"
              @change="newColorStyleSubmitted"
              placeholder="Type new color style name"
            />
            <p
              class="input-switcher"
              @click="
                switchToManualColorStyleInput = !switchToManualColorStyleInput
              "
              v-if="!isReadOnlyUser"
            >
              {{
                switchToManualColorStyleInput
                  ? "Select existing color style"
                  : "Create new color style"
              }}
            </p>
            <small
              v-if="errors.default_coloring_style"
              class="form-text text-danger"
              >{{ errors.default_coloring_style.join(" ") }}</small
            >
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Button Color</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.button_color_id"
              :options="fieldValues.buttonColors"
              label="title"
              :reduce="(buttonColor) => buttonColor.id"
            />
            <small
              v-if="errors.button_color_id"
              class="form-text text-danger"
              >{{ errors.button_color_id.join(" ") }}</small
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Thread Color</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.thread_color_id"
              :options="fieldValues.threadColors"
              label="title"
              :reduce="(threadColor) => threadColor.legacy_id"
            />
            <small
              v-if="errors.thread_color_id"
              class="form-text text-danger"
              >{{ errors.thread_color_id.join(" ") }}</small
            >
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Embroidery</label>
          <div class="col-sm-7">
            <v-select
              placeholder="Choose One"
              v-model="modelValues.embroidery_thread_color_id"
              :options="fieldValues.embroideryThreadColors"
              label="title"
              :reduce="(threadColor) => threadColor.legacy_id"
            />
            <small
              v-if="errors.embroidery_thread_color_id"
              class="form-text text-danger"
              >{{ errors.embroidery_thread_color_id.join(" ") }}</small
            >
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Fabric Family</label>
          <div class="col-sm-7">
            <multiselect
              v-model="modelValues.families"
              placeholder="Search a Fabric Family"
              label="title_en"
              track-by="id"
              :options="fieldValues.fabricFamilies"
              :multiple="true"
              :taggable="true"
            >
            </multiselect>
            <small v-if="errors.families" class="form-text text-danger">{{
              errors.families.join(" ")
            }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Special characteristic</label>
          <div class="col-sm-7">
            <input
              type="text"
              class="form-control"
              v-model="modelValues.special_description_suffix"
            />
            <small
              v-if="errors.special_description_suffix"
              class="form-text text-danger"
              >{{ errors.special_description_suffix.join(" ") }}</small
            >
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Description</label>
          <div class="col-sm-7">
            <textarea
              class="form-control"
              v-model="modelValues.description"
              rows="3"
            ></textarea>
            <small v-if="errors.description" class="form-text text-danger">{{
              errors.description.join(" ")
            }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">English Description</label>
          <div class="col-sm-7">
            <textarea
              class="form-control"
              v-model="modelValues.description_en"
              rows="3"
            ></textarea>
            <small v-if="errors.description_en" class="form-text text-danger">{{
              errors.description_en.join(" ")
            }}</small>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-3">
        <label class="mt-10">Comfort</label>
      </div>
      <div class="col-md-3">
        <input
          type="number"
          class="form-control slider-value"
          v-model="modelValues.comfort"
          step="0.5"
          min="1.0"
          max="5.0"
        />
        <small v-if="errors.comfort" class="form-text text-danger">{{
          errors.comfort.join(" ")
        }}</small>
      </div>
      <div class="col-md-3">
        <label class="mt-10">Easy Ironing</label>
      </div>
      <div class="col-md-3">
        <input
          type="number"
          class="form-control slider-value"
          v-model="modelValues.ironing"
          step="0.5"
          min="1.0"
          max="5.0"
        />
        <small v-if="errors.ironing" class="form-text text-danger">{{
          errors.ironing.join(" ")
        }}</small>
      </div>
    </div>

    <hr />

    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Status</label>
          <div class="col-sm-7">
            <select class="form-control" v-model="modelValues.status">
              <option
                :value="status.key"
                v-for="status in statuses"
                :key="status.key"
              >
                {{ status.title }}
              </option>
            </select>
            <small v-if="errors.status" class="form-text text-danger">{{
              errors.status.join(" ")
            }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label">Future</label>
          <div class="col-sm-7">
            <select class="form-control" v-model="modelValues.future">
              <option value="keep">Keep</option>
              <option value="out">Out</option>
            </select>
            <small v-if="errors.future" class="form-text text-danger">{{
              errors.future.join(" ")
            }}</small>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group row">
          <label class="col-sm-5 col-form-label"
            >Next Delivery Information</label
          >
          <div class="col-sm-7">
            <input type="date" class="swal2-input" v-model="modelValues.note" />
            <small v-if="errors.note" class="form-text text-danger">{{
              errors.note.join(" ")
            }}</small>
          </div>
          <div
            class="col-sm-12 mt-10 text-bold status-note"
            v-if="modelValues.note && modelValues.status == 'inactive'"
          >
            Status Note ( {{ modelValues.note }} )
          </div>
          <div
            class="col-sm-12 mt-10 text-bold status-note"
            v-else-if="modelValues.note && modelValues.status !== 'inactive'"
          >
            Available date ( {{ modelValues.note }} )
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import VueInput from "@/pages/Tools/input";
import Multiselect from "vue-multiselect";

export default {
  components: {
    VueSlider,
    VueInput,
    Multiselect,
  },
  props: {
    fieldValues: {
      type: [Object],
      default: {},
    },
    modelValues: {
      type: [Object],
      default: {},
    },
    errors: {
      type: [Object],
      default: {},
    },
    isReadOnlyUser: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statuses: [
        { key: "available", title: "Available" },
        {
          key: "soon_sold_out_coming_back",
          title: "Soon sold out coming back",
        },
        {
          key: "soon_sold_out_not_coming_back",
          title: "Soon sold out not coming back",
        },
        { key: "sold_out_coming_back", title: "Sold out coming back" },
        { key: "sold_out_not_coming_back", title: "Sold out not coming back" },
        { key: "not_released_yet", title: "Not released yet" },
        { key: "inactive", title: "Inactive" },
      ],
      value: [],
      options: [],
      switchToManualFinishingInput: false,
      switchToManualColorStyleInput: false,
    };
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    async newFinishingSubmitted(event) {
      const label = event.target.value;
      await this.createNewFabricProperty(
        "finishing",
        label,
        this.fieldValues.finishes
      );
      this.switchToManualFinishingInput = false;
    },
    async newColorStyleSubmitted(event) {
      const label = event.target.value;
      await this.createNewFabricProperty(
        "color_style",
        label,
        this.fieldValues.coloringStyles
      );
      this.switchToManualColorStyleInput = false;
    },
    /**
     *
     * @param option
     * @param label
     * @param existingLabels
     * @returns {Promise<void>}
     */
    async createNewFabricProperty(fabricProperty, label, existingLabels) {
      const formData = new FormData();
      formData.append("label", label);
      formData.append("fabric_property", fabricProperty);
      if (label) {
        let index = existingLabels.findIndex((x) => x === label);
        // Save the option if it does not exist yet
        if (index === -1) {
          try {
            existingLabels.push(label);
            await axios.post("v2/fabrics/property", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
            toastr.success("Successfully created");
          } catch (error) {
            if (error.response.status === 403) {
              toastr.error(
                "Not authorized, please ensure that you have the required permissions."
              );
            } else {
              const errorMessage = error.response.data.message;
              toastr.error("An error occurred: " + errorMessage);
            }
          }
        } else {
          toastr.error("That option already exists");
        }
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.status-note {
  border-top: 1px solid #5e71e4;
  border-bottom: 1px solid #5e71e4;
  padding: 6px;
}
.input-switcher {
  position: absolute;
  /*bottom: -28px;*/
  left: 20px;
  font-size: 12px;
  color: var(--primary-color);
  cursor: pointer;
}
.mt-10 {
  margin-top: 10px;
}
</style>
